import { SplitButton, useOpen } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CreateCarFleetApplicationDrawer } from "./CreateCarFleetApplication";
import { CreateMailcoachApplicationDrawer } from "./CreateMailcoachApplication";

export const CreateApplicationAction: FC = () => {
	const { t } = useTranslation();
	const { open: openCarFleet, handleOpen: handleOpenCarFleet, handleClose: handleCloseCarFleet } = useOpen();
	const { open: openMailcoach, handleOpen: handleOpenMailcoach, handleClose: handleCloseMailcoach } = useOpen();

	return (
		<>
			<SplitButton
				size="small"
				color="primary"
				options={[
					{ title: t("Car fleet"), onClick: handleOpenCarFleet },
					{ title: t("Newsletter"), onClick: handleOpenMailcoach },
				]}
			/>
			<CreateCarFleetApplicationDrawer open={openCarFleet} onClose={handleCloseCarFleet} />
			<CreateMailcoachApplicationDrawer open={openMailcoach} onClose={handleCloseMailcoach} />
		</>
	);
};
